import React from 'react';
import { Box, Card, CardContent, InputAdornment, TextField } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

/**
 * La barre de recherche et de filtres, commune aux écrans de liste.
 *
 * ⚠️ LE PÉRIMÈTRE VIENT D'UNE MESURE, PAS D'UNE INTUITION. L'énoncé du lot
 * parlait de « trois filtres sur Produits, deux sur Commandes, un sur
 * Fournisseurs ». Compté dans les fichiers : Produits et Commandes ont **un
 * champ de recherche et deux `Select`** ; les 8 `TextField` de Fournisseurs
 * sont dans son **dialogue de création**, pas dans sa barre. Le cas à couvrir
 * est donc unique et modeste : *recherche + 0 à 2 filtres*. C'est ce qui rend
 * un composant commun réalisable ici sans le rendre générique.
 *
 * Même principe que `EnteteEcran` : deux props nommées et `children`. Les
 * filtres sont écrits par l'écran, parce qu'ils dépendent de ses données ; ce
 * composant ne décide que de la MISE EN PAGE — même hauteur, même gouttière,
 * même surface, partout.
 *
 *     <BarreFiltres valeur={terme} onChange={setTerme}>
 *       <TextField select … />
 *     </BarreFiltres>
 */
const BarreFiltres = ({
  valeur,
  onChange,
  libelle,
  children,
  // ⚠️ `actions` plutôt que d'entasser dans `children` : sur Produits, le
  // bouton « Commander » vit dans la barre de filtres et n'est PAS un filtre.
  // Les mélanger obligerait le composant à deviner lequel est lequel.
  actions,
}) => (
  <Card sx={{ mb: 3 }}>
    <CardContent
      sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'center',
        flexWrap: 'wrap',
        // ⚠️ Le `:last-child` de MUI ajoute 24px de padding en bas d'un
        // CardContent. Ici le contenu est une seule rangée : ce surplus créait
        // une barre deux fois trop haute, et c'est l'une des raisons pour
        // lesquelles les écrans n'avaient pas la même hauteur de filtres.
        '&:last-child': { pb: 2 },
      }}
    >
      <TextField
        size="small"
        label={libelle}
        value={valeur}
        onChange={(e) => onChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
        // La recherche prend la place restante, les filtres gardent la leur.
        sx={{ flex: '1 1 240px', minWidth: 200 }}
      />
      {children}
      {actions ? <Box sx={{ ml: 'auto' }}>{actions}</Box> : null}
    </CardContent>
  </Card>
);

export default BarreFiltres;
